import { AppDispatch } from '../utils'
import { updateActionsTimestamps } from './actionsTimestamps/actions'

export type StructureSerializedDataSource = {
	data?: string
	lockUserId?: number
	workingData?: string
}

export const isPlaceholderStructureData = (serialized?: string): boolean => {
	if (serialized == null || serialized.trim() === '') return true
	const trimmed = serialized.trim()
	return trimmed === '{}' || trimmed.toLowerCase() === 'null'
}

/**
 * Published `data` in read mode; draft `workingData` when editing or when explicitly
 * refreshing the working copy (e.g. AI assistant updates on a read-only tab).
 * When a structure is locked and not yet pushed, read mode still shows the draft.
 */
export const getStructureSerializedData = (
	node: StructureSerializedDataSource,
	editMode: boolean,
	refreshWorkingCopy = false,
): string | undefined => {
	if (editMode || refreshWorkingCopy) {
		return node.workingData || node.data
	}

	if (
		node.lockUserId &&
		node.workingData &&
		isPlaceholderStructureData(node.data)
	) {
		return node.workingData
	}

	return node.data
}

/**
 * Ensure that data match TS / JSON schema
 * @param data data to validate
 * @param defaultData proper data according to TS typings
 * @param keys  keys of defaultData
 */
export const ensureValidData = <T extends object>(
	data: Partial<T>,
	defaultData: T,
): T => {
	const result = { ...data }
	const keys = Object.keys(defaultData) as (keyof T)[]

	keys.forEach((key) => {
		if (result[key] === undefined) {
			;(result[key] as T[keyof T]) = defaultData[key]
		}
	})

	return result as T
}

export const setTimestampStart = (
	dispatch: AppDispatch,
	actionType: string,
	id: number | string,
) => {
	const timeStamp = Date.now()

	dispatch(
		updateActionsTimestamps({
			id,
			actionType,
			start: timeStamp,
		}),
	)

	return timeStamp
}
